module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/multiple-properties-location-306662986c6ad5780b9cb629a1d0d73e.svg";